import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { getImagesList, ImageOutput } from '../endpoints/images/list_GET.schema';
import { generateImage } from '../endpoints/images/generate_POST.schema';

export const useGeneratedImages = (sessionId: string | null) => {
  return useQuery({
    queryKey: ['images', sessionId],
    queryFn: () => getImagesList({ sessionId: sessionId! }),
    enabled: !!sessionId,
  });
};

export const useGenerateImage = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: generateImage,
    onSuccess: (_, variables) => {
      if (variables.saveToSession !== false) {
        queryClient.invalidateQueries({ queryKey: ['images', variables.sessionId] });
      }
    },
  });
};

export type { ImageOutput };
